import React, { useState, useEffect } from 'react';
import { getWholesalerById } from '../../services/api';

const WholesalerName = ({ wholesalerId }) => {
    const [name, setName] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!wholesalerId) {
            setIsLoading(false);
            return;
        }

        let isMounted = true;
        setIsLoading(true);
        getWholesalerById(wholesalerId)
            .then(data => {
                if (isMounted && data) {
                    setName(data.merchantName || data.name || data.id || wholesalerId);
                }
            })
            .catch(err => {
                console.error("Error fetching wholesaler info:", err);
                // Fallback to displaying ID if there's an error
                if (isMounted) setName(wholesalerId);
            })
            .finally(() => {
                if (isMounted) setIsLoading(false);
            });

        return () => { isMounted = false; };
    }, [wholesalerId]);

    if (!wholesalerId) return null;

    if (isLoading) {
        // Smooth pulsing skeleton loader for the name
        return (
            <div className="mt-1 w-24 h-3 bg-gray-200 rounded animate-pulse"></div>
        );
    }

    if (!name) return null;

    return <div className="text-xs text-gray-500 mt-0.5">{name}</div>;
};

export default WholesalerName;
